import { GfReduxAction } from 'gf-types';
import {
  GoFormzAgentTemplateContext,
  GoFormzAgentWorkflowContext,
  GoFormzAgentDatasourceContext,
  GoFormzAgentFormContext,
  GoFormzAgentContextTypes,
  GoFormzAgentContextPayload
} from './goFormz-agent-types';

export type GoFormzAgentAction = GfReduxAction<GoFormzAgentContextPayload>;
export type ApplyGoFormzAgentContextAction = (
  contextType: GoFormzAgentContextTypes,
  context: GoFormzAgentTemplateContext | GoFormzAgentWorkflowContext | GoFormzAgentDatasourceContext | GoFormzAgentFormContext
) => void;

export const applyGoFormzAgentContext = (
  contextType: GoFormzAgentContextTypes,
  context: GoFormzAgentTemplateContext | GoFormzAgentWorkflowContext | GoFormzAgentDatasourceContext | GoFormzAgentFormContext
): GoFormzAgentAction => {
  return {
    type: contextType, // Use the provided enum value as the type
    payload: { contextType, context }
  };
};
